import { v4 as uuidv4 } from 'uuid';
import { z } from 'zod';
import { type AreEqual, assertTypes } from '../primitives';

export const POS_PASSCODE_ROLES = ['MANAGER', 'STAFF'] as const;
export const zPosPasscodeRole = z.literal(POS_PASSCODE_ROLES);

export const posPasscodeSchema = z.object({
  uuid: z.string().default(() => uuidv4()),
  name: z.string(),
  passcode: z.string(),
  role: zPosPasscodeRole,
});
export type PosPasscode = z.output<typeof posPasscodeSchema>;

export const posPasscodeStrictSchema = posPasscodeSchema.safeExtend({
  passcode: z.string().regex(/^\d{4}$/, 'Passcode must be exactly 4 digits'),
  name: z.string().trim().min(1, 'Name is required'),
});
/** The strict schema should not change the output types */
assertTypes<AreEqual<PosPasscode, z.infer<typeof posPasscodeStrictSchema>>>();
